<template>
  <div
    style="height: 100%"
    ref="amenities"
    :class="{ right_content: language == 'ar' }"
  >
    <van-sticky>
      <van-nav-bar
        class="header"
        :title="stringList[meetingService]"
        @click-left="$emit('onClickLeft')"
      >
        <template #left>
          <img
            src="@/assets/img/back_new.png"
            style="width: 20px; height: 20px"
          />
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="container">
      <div class="form-title">
        <span>{{ stringList.new_request }}</span>
      </div>
      <div class="form">
        <div class="form-item required">
          <a-select
            show-search
            size="large"
            class="roomNum"
            ref="select1"
            :value="roomNumber"
            :placeholder="stringList.enter_room"
            :getPopupContainer="() => $refs.amenities"
            :default-active-first-option="false"
            :filter-option="false"
            :not-found-content="null"
            @search="(val) => $emit('roomSearch', val)"
            @change="(val) => $emit('roomChange', val)"
            @focus="$emit('clearRoomNumber')"
            :autofocus="false"
            dropdownClassName="roomNumber"
            :notFoundContent="notFoundContent"
          >
            <template #suffixIcon>
              <img
                style="width: 15px"
                src="@/assets/img/hotel-please-clean.png"
              />
            </template>
            <a-select-option
              v-for="item in roomArray"
              :key="item.id"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>

        <div
          class="form-item required"
          v-if="meetingService && meetingServiceType != 'Temperature Control'"
        >
          <van-field
            :value="meetingRequest"
            style="height: auto"
            type="textarea"
            maxlength="50"
            rows="3"
            :placeholder="stringList.enter_your_request"
            class="request-form"
            @input="(val) => $emit('update:meetingRequest', val)"
          />
        </div>

        <div
          class="form-item"
          v-if="meetingService && meetingServiceType == 'Temperature Control'"
        >
          <div class="avAssistanceTitle">
            {{ stringList.SelectTypeService }}
          </div>
          <van-row>
            <van-col span="11">
              <div
                :class="[
                  'avAssistanceGroup-row',
                  meetingRequest == stringList.MakeCooler
                    ? 'avAssistanceGroup-row-sel'
                    : '',
                ]"
                @click="$emit('focusMeetingRequest', stringList.MakeCooler)"
              >
                <!-- <img src="@/assets/img/xuehua.png" alt="" />
                <span>{{ stringList.MakeCooler }}</span> -->
                <svg-icon iconClass="xuehua" className="xuehua" />
                <span>{{ stringList.MakeCooler }}</span>
              </div>
            </van-col>
            <van-col span="2">
              <div></div>
            </van-col>
            <van-col span="11">
              <div
                :class="[
                  'avAssistanceGroup-row',
                  meetingRequest == stringList.MakeWarmer
                    ? 'avAssistanceGroup-row-sel'
                    : '',
                ]"
                @click="$emit('focusMeetingRequest', stringList.MakeWarmer)"
              >
                <!-- <img src="@/assets/img/taiyang.png" alt="" />
                <span>{{ stringList.MakeWarmer }}</span> -->
                <svg-icon iconClass="taiyang" className="taiyang" />
                <span>{{ stringList.MakeWarmer }}</span>
              </div>
            </van-col>
          </van-row>

          <van-field
            :value="meetingRequest"
            style="height: auto; margin-top: 12px"
            type="textarea"
            maxlength="50"
            rows="3"
            :placeholder="stringList.EnterOtherRequest"
            class="request-form"
            @input="(val) => $emit('update:meetingRequest', val)"
          />
        </div>

        <!-- 日期控件 -->
        <van-row>
          <van-col span="11">
            <div class="form-item required">
              <van-field
                readonly
                :placeholder="stringList.today"
                :value="date"
                @click="$emit('deteSelect')"
                :class="{ placeholderColor: date == '' }"
              >
                <template #right-icon>
                  <img
                    src="@/assets/img/calendar-line.png"
                    style="height: 15px"
                  />
                </template>
              </van-field>
            </div>
          </van-col>
          <van-col span="2"><div></div></van-col>
          <van-col span="11">
            <div class="form-item required">
              <van-field
                readonly
                :value="time"
                @click="$emit('selectTime')"
                :placeholder="stringList.asap"
                :class="{ placeholderColor: time == '' }"
              >
                <template #right-icon>
                  <img src="@/assets/img/clock-time.png" style="height: 15px" />
                </template>
              </van-field>
            </div>
          </van-col>
        </van-row>

        <div class="form-item">
          <van-field
            :value="notes"
            @input="(val) => $emit('update:notes', val)"
            style="height: auto"
            type="textarea"
            rows="3"
            maxlength="200"
            :placeholder="stringList.comments_placeholder"
            class="comment"
          />
        </div>

        <div class="form-item" v-if="showPhone != 0">
          <span
            class="text"
            style="font-size: 15px"
            :class="{ right_text_item: language == 'ar' }"
          >
            <span
              :class="{ right_text_item: language == 'ar' }"
              style="display: block"
              >{{
                showPhone === 1 ? stringList.optional1 : stringList.optional3
              }}&nbsp;&nbsp;{{
                showPhone === 1 ? stringList.optional2 : stringList.optional5
              }}</span
            >
          </span>
        </div>
        <div
          :class="['form-item', { required: showPhone === 2 }]"
          v-if="showPhone != 0"
        >
          <van-field
            :value="phone"
            type="tel"
            :placeholder="stringList.mobile_number"
            maxlength="12"
            @input="(val) => $emit('validateMobile', val)"
          ></van-field>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- <div class="btn" @click="createOrder" :style="{ color: modifiedColor }">
        <span>{{ stringList.submit }}</span>
      </div> -->
      <van-button @click="$emit('createOrder')" class="btn">{{
        stringList.submit
      }}</van-button>
    </div>
    <!--  日历控件  -->
    <van-calendar
      v-model="showDate"
      :color="primaryColor"
      :show-title="false"
      :min-date="getMinDate()"
      :default-date="getDefaultDate()"
      @confirm="(val) => $emit('dateConfirm', val)"
    />

    <!-- 时间选择 -->
    <van-popup v-model="showTime" position="bottom">
      <van-picker
        :columns="timeColumns"
        show-toolbar
        @confirm="(val) => $emit('timeConfirm', val)"
        @cancel="$emit('update:showTime', false)"
      />
    </van-popup>

    <!-- 特殊流程弹窗 -->
    <van-popup
      v-model="confirmationPop"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :get-container="() => $refs.amenities"
    >
      <div class="pop">
        <div class="pop-title" style="margin-bottom: 20px">
          <span class="title">{{ stringList.confirmation }}</span>
        </div>
        <div class="pop-info" style="padding: 0 40px">
          <div
            v-if="
              selectRequest.section != 'ScheduleAfterHour' &&
              selectRequest.section != 'ScheduleNextDay'
            "
            class="text"
            style="font-size: 14px"
            :class="{ right_text_item: language == 'ar' }"
          >
            {{ confirmation1 }}
          </div>
          <div
            class="text"
            style="margin-bottom: 20px; font-size: 14px"
            :class="{ right_text_item: language == 'ar' }"
          >
            {{ confirmation }}
          </div>
          <div
            style="display: flex; align-items: center; justify-content: center"
          >
            <van-radio-group
              :value="fdAction"
              icon-size="14"
              direction="horizontal"
              style="
                justify-content: space-between;
                width: 150px;
                margin-bottom: 10px;
              "
            >
              <van-radio
                shape="square"
                name="Yes"
                @click="$emit('update:fdAction', 'Yes')"
              >
                <span>{{ stringList.yes }}</span></van-radio
              >
              <van-radio
                shape="square"
                name="No"
                @click="$emit('update:fdAction', 'No')"
              >
                <span>{{ stringList.no }}</span></van-radio
              >
            </van-radio-group>
          </div>
        </div>
        <div class="btn-area" style="border-top: 0px">
          <!-- <div class="btn" @click="confirmationPopOK">
            <span>{{ stringList.ok }}</span>
          </div> -->
          <van-button @click="$emit('confirmationPopOK')" class="btn">{{
            stringList.ok
          }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- TransferToFD或者TransferToRS yes分支弹窗 -->
    <van-popup
      v-model="thankPop2"
      style="width: 300px"
      round
      :close-on-click-overlay="false"
      :get-container="() => $refs.amenities"
    >
      <div class="pop">
        <div
          class="pop-title3"
          style="margin-bottom: 20px"
          :class="{ right_keywords_title: language == 'ar' }"
        >
          <span class="title">{{ stringList.thank }}</span>
        </div>
        <div class="pop-info">
          <div class="text" :class="{ right_text_item: language == 'ar' }">
            <!-- {{ okContent }} -->
            {{ stringList.responseContent4 }}
            <span v-if="language == 'en'">{{ selectRequest.keyword }}.</span>
            <span v-else>{{ selectRequest[language] }}.</span>
          </div>
        </div>
        <div class="btn-area" style="border-top: 0px">
          <!-- <div class="btn" @click="() => $router.go(-1)">
            <span>{{ stringList.ok }}</span>
          </div> -->
          <van-button @click="() => $router.go(-1)" class="btn">{{
            stringList.ok
          }}</van-button>
        </div>
      </div>
    </van-popup>
    <!-- Answer分支弹窗 -->
    <van-popup
      v-model="thankPop3"
      style="width: 300px"
      round
      :close-on-click-overlay="false"
      :get-container="() => $refs.amenities"
    >
      <div class="pop">
        <div
          class="pop-title3"
          style="margin-bottom: 20px"
          :class="{ right_keywords_title: language == 'ar' }"
        >
          <span class="title">{{ stringList.thank }}</span>
        </div>
        <div class="pop-info">
          <div class="text" :class="{ right_text_item: language == 'ar' }">
            {{ stringList.your_request }}
          </div>
          <div
            class="info-item"
            style="margin-bottom: 10px; font-weight: 600"
            :class="{ right_keywords_item: language == 'ar' }"
          >
            <span v-if="language == 'en'">{{ selectRequest.keyword }}</span>
            <span v-else>{{ selectRequest[language] }}</span>
          </div>
          <div class="text" :class="{ right_text_item: language == 'ar' }">
            {{ okContent }}
          </div>
          <template v-for="(file, index) in fileList">
            <div
              :key="index"
              v-if="$emit('showPdf', selectRequest.keyword, file)"
              @click="$emit('pdfView', file.fileUrl, file.title)"
              class="text"
              style="text-decoration: underline"
              :class="{ right_text_item: language == 'ar' }"
            >
              {{ JSON.parse(file.title2)[language] }}
            </div>
          </template>
        </div>
        <div class="btn-area" style="border-top: 0px">
          <!-- <div class="btn" @click="() => $router.go(-1)">
            <span>{{ stringList.ok }}</span>
          </div> -->
          <van-button @click="() => $router.go(-1)" class="btn">{{
            stringList.ok
          }}</van-button>
        </div>
      </div>
    </van-popup>
    <!-- submit弹窗  meeting-->
    <van-popup
      v-model="thankPop"
      style="width: 300px"
      round
      :close-on-click-overlay="false"
      :get-container="() => $refs.amenities"
    >
      <div class="pop">
        <div
          class="pop-title3"
          style="margin-bottom: 20px"
          :class="{ right_keywords_title: language == 'ar' }"
        >
          <span class="title">{{ stringList.thank }}</span>
        </div>
        <div class="pop-info">
          <div class="text" :class="{ right_text_item: language == 'ar' }">
            {{ stringList.responseContent1 }}
          </div>
          <div>
            <div
              class="info-item"
              style="font-weight: 600"
              :class="{ right_keywords_item: language == 'ar' }"
            >
              <span>{{ meetingServiceTitle }}</span>
            </div>
          </div>
          <div
            class="text"
            :class="{ right_text_item: language == 'ar' }"
            style="padding-left: 20px"
          >
            {{ tips }}
          </div>

          <div class="text" :class="{ right_text_item: language == 'ar' }">
            {{
              pageType == "nonguest" ? okContent : stringList.responseContent2
            }}
          </div>
        </div>
        <div class="btn-area" style="border-top: 0px">
          <van-button @click="() => $router.go(-1)" class="btn">{{
            stringList.ok
          }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Vue from "vue";
export default {
  props: {
    date: {
      type: String,
      default: "",
    },
    time: {
      type: String,
      default: "",
    },
    notes: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    fdAction: {
      type: String,
      default: "",
    },
    language: {
      type: String,
      default: "",
    },
    showPhone: {
      type: [Number, String],
      default: 0,
    },
    stringList: {
      default: () => {},
    },
    roomNumber: {
      type: [String, undefined],
      default: undefined,
    },
    notFoundContent: {
      type: String,
      default: "",
    },
    roomArray: {
      type: Array,
      default: () => [],
    },
    meetingService: {
      type: String,
      default: "",
    },
    meetingRequest: {
      type: String,
      default: "",
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: "",
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    timeColumns: {
      type: Array,
      default: () => [],
    },
    confirmationPop: {
      type: Boolean,
      default: false,
    },
    selectRequest: {
      type: Object,
      default: () => {},
    },
    confirmation: {
      type: Boolean,
      default: false,
    },
    confirmation1: {
      type: String,
      default: "",
    },
    confirmation2: {
      type: String,
      default: "",
    },
    thankPop2: {
      type: Boolean,
      default: false,
    },
    thankPop3: {
      type: Boolean,
      default: false,
    },
    thankPop: {
      type: Boolean,
      default: false,
    },
    meetingServiceType: {
      type: String,
      default: "",
    },
    meetingServiceTitle: {
      type: String,
      default: "",
    },
    tips: {
      type: String,
      default: "",
    },
    pageType: {
      type: String,
      default: "",
    },
    okContent: {
      type: String,
      default: "",
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDefaultDate() {
      let date = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD");
      return new Date(date);
    },
    getMinDate() {
      let date = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD");
      // console.log(date);
      return new Date(date);
    },
  },
};
</script>

<style lang="scss" scoped>
.right_keywords_title {
  display: grid !important;
  text-align: right !important;
}
.right_keywords_item {
  text-align: right !important;
}
.right_content {
  /deep/.ant-select-selection__placeholder {
    text-align: right !important;
  }
  /deep/.van-field__control {
    text-align: right !important;
  }
  /deep/.ant-select {
    text-align: right !important;
    direction: rtl;
  }
  /deep/.ant-select-dropdown-menu-item {
    text-align: right !important;
  }
}
.right_text_item {
  text-align: right !important;
}
.header {
  /deep/.van-nav-bar__content {
    height: 50px;
    background-color: #f3f3f3;
    .van-nav-bar__title {
      font-size: 18px;
      // line-height: 20px;
      font-family: $fontFamily;
      color: #4f4f4f;
      font-weight: 400;
    }
    .van-nav-bar__arrow {
      color: #bbbbbb;
      font-size: 22px;
    }
  }
}

.bottom {
  height: 104px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;

  .btn {
    height: 47px;
    width: 167px;
    border-radius: 20px;
    background-color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;

    span {
      font-size: 16px;
      line-height: 18px;
      font-family: $fontFamily;
      color: #ffffff;
    }
  }
}

.container::-webkit-scrollbar {
  display: none;
}

.container {
  height: calc(100% - 155px);
  background-color: #fff;
  width: 100%;
  padding: 20px 30px;
  overflow-y: auto;

  .form-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    word-break: normal;
    position: relative;
    margin-bottom: $form-title-margin-bottom;

    span {
      color: #333333;
      font-size: 16px;
      line-height: 18px;
      font-family: $fontFamily;
    }

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #e8e8e8;
    }
  }

  .form {
    padding-left: 10px;
    word-break: normal;

    .required {
      position: relative;

      &:before {
        position: absolute;
        content: "*";
        left: -15px;
        width: 15px;
        height: 40px;
        top: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .form-item {
      font-size: 15px;
      word-break: normal;
      text-align: left;
      margin-bottom: 20px;
      line-height: 17px;
      font-family: $fontFamily;

      .van-field {
        min-height: 40px;
        border-radius: 6px;
        color: #9a9a9a;
        background-color: #f3f3f3;
        width: 100%;
        padding: 0 15px;
        display: flex;
        align-items: center;
        height: 100%;
        font-family: $fontFamily;
        line-height: 17px;
        font-size: 15px;

        ::-webkit-input-placeholder {
          color: #9a9a9a !important;
        }
      }
      .request-form {
        /deep/.van-field__control {
          height: 56px;
          min-height: 0;
          overflow-y: hidden;
        }
        /deep/.van-field--min-height {
          min-height: 0;
        }
      }

      .comment {
        padding: 0 10px 0 15px;
      }
      .placeholderColor {
        ::-webkit-input-placeholder {
          color: #323233 !important;
        }
      }

      .text {
        font-size: 15px;
        line-height: 17px;
        font-family: $fontFamily;
        color: #4f4f4f;
      }

      .roomNum {
        width: 100%;
        font-size: 15px;
        line-height: 17px;
        font-family: $fontFamily;
        color: #323233;
      }

      /deep/.ant-select-selection {
        border-color: transparent;
        background-color: #f3f3f3;
        border-radius: 6px;
        box-shadow: none !important;
      }
      /deep/.ant-select-selection__placeholder {
        color: #9a9a9a;
      }
      /deep/.ant-select-selection:hover {
        border-color: transparent;
        box-shadow: 0 0 0 1px #9a94c0 !important;
      }

      /deep/textarea {
        padding: 10px 0 !important;
      }
    }

    .form-item2 {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .van-field {
        width: 215px;
      }

      .van-stepper {
        display: flex;
        flex-flow: nowrap;
      }

      /deep/.van-stepper--round .van-stepper__minus {
        background-color: #ffffff;
        color: #1e4380;
        border: 1px solid #1e4380;
      }

      /deep/.van-stepper--round .van-stepper__plus {
        background-color: #ffffff;
        color: #1e4380;
        border: 1px solid #1e4380;
      }
    }

    .form-item2:last-child {
      margin-bottom: 0px;
    }

    .form-item3 {
      height: 40px;
      text-align: left;
      display: flex;
      align-items: center;

      span {
        line-height: 16px;
        font-size: 14px;
        word-break: normal;
        font-family: $fontFamily;
        color: #1e4380;
      }
    }
  }
}

/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}

/deep/.van-nav-bar__title {
  max-width: 80%;
}

// /deep/.van-ellipsis{
//   white-space: pre-wrap;
// }

// .title_mini_font {
//   /deep/ .van-nav-bar__title {
//     font-size: 13px !important;
//   }
// }
.van-popup--bottom.van-popup--round {
  border-radius: 12px 12px 0 0;
}

.van-popup--center.van-popup--round {
  border-radius: 6px;
}

.pop {
  word-break: normal;
  text-align: left;
  max-height: 80vh;

  .pop-title {
    margin: 0 30px;
    height: 60px;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 18px;
      line-height: 20px;
      color: #1e4380;
      font-weight: 600;
    }

    .icon {
      font-size: 22px;
      color: #bbbbbb;
      position: absolute;
      left: 0px;
    }

    .shopping {
      font-size: 30px;
      color: #bbbbbb;
      position: absolute;
      right: 0px;
    }

    .van-badge__wrapper {
      display: flex;
    }

    /deep/.van-badge--fixed {
      top: 5px;
      right: 5px;
    }
  }

  .pop-title3 {
    margin: 0 20px;
    padding-bottom: 10px;
    height: 70px;
    display: flex;
    align-items: end;
    // justify-content: center;
    position: relative;
    border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 20px;
      line-height: 22px;
      color: #1e4380;
      font-weight: 600;
    }
  }

  .pop-title2 {
    margin: 0 20px;
    padding-bottom: 10px;
    height: 70px;
    display: flex;
    align-items: end;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #e8e8e8;

    .title {
      font-family: $fontFamily;
      font-size: 20px;
      line-height: 22px;
      color: #1e4380;
      font-weight: 600;
    }
  }

  .pop-container {
    padding: 0 30px;
    max-height: calc(80vh - 160px);
    overflow-y: auto;

    .pop-item {
      // height: $pop-item-height;
      min-height: 50px;
      padding: 10px 0;
      border-top: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 22px;
        margin-right: 25px;
      }
      .text {
        flex: 1;
        color: #000000;
        font-size: 15px;
        line-height: 17px;
        font-family: $fontFamily;
        margin-right: 10px;
      }
      .icon {
        font-size: 18px;
        color: #bbbbbb;
      }

      .select {
        background-color: $primary-color;
        border: 1px solid $primary-color !important;
        color: #ffffff !important;
      }

      .btn {
        height: 25px;
        width: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        border: 1px solid #bbbbbb;
        color: #4f4f4f;

        span {
          font-size: 14px;
          line-height: 16px;
          font-family: $fontFamily;
        }
      }

      &:first-child {
        border-top: 0px;
      }
    }

    .other-select {
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom: 30px;
      padding-left: 50px;

      .select-other {
        width: 100%;
        // margin-left: 50px;
        font-size: 15px;
        font-family: $fontFamily;
      }

      /deep/.ant-select-selection {
        border-color: transparent;
        background-color: #f3f3f3;
        border-radius: 6px;
        box-shadow: none !important;
      }
      /deep/.ant-select-selection__placeholder {
        color: #9a9a9a;
      }
      /deep/.ant-select-selection:hover {
        border-color: transparent;
        box-shadow: 0 0 0 1px #9a94c0 !important;
      }
    }

    .van-stepper {
      display: flex;
      flex-flow: nowrap;
    }

    /deep/.van-stepper--round .van-stepper__minus {
      background-color: #ffffff;
      color: #1e4380;
      border: 1px solid #1e4380;
    }

    /deep/.van-stepper--round .van-stepper__plus {
      background-color: #ffffff;
      color: #1e4380;
      border: 1px solid #1e4380;
    }
  }

  .btn-area {
    height: 100px;
    border-top: 2px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      height: 47px;
      width: 167px;
      border-radius: 20px;
      background-color: $primary-color;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 16px;
        line-height: 18px;
        font-family: $fontFamily;
        color: #ffffff;
      }
    }
  }

  .pop-info {
    padding: 0 40px;
    .text {
      font-size: 15px;
      line-height: 19px;
      color: #000000;
      font-family: $fontFamily;
      margin-bottom: 11px;
      word-wrap: break-word;
      word-break: normal;
    }

    .info-item {
      padding-left: 20px;
      font-size: 15px;
      line-height: 20px;
      color: #000000;
      font-family: $fontFamily;
      position: relative;

      &:before {
        position: absolute;
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #000;
        left: 0px;
        top: 7px;
      }
    }

    .info-item:last-child {
      margin-bottom: 11px;
    }

    /deep/.van-radio__label {
      font-size: 15px;
      line-height: 17px;
      color: #333333;
      font-family: $fontFamily;
    }

    /deep/.van-radio__icon--checked .van-icon {
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }
}

/deep/.ant-select-dropdown {
  z-index: 9999;
  text-align: left;
}
/deep/.ant-select-dropdown-menu-item {
  font-size: 17px;
  color: #000000;
  line-height: 24px;
  font-family: $fontFamily;
}
/deep/.ant-select-dropdown-menu-item:hover:not(
    .ant-select-dropdown-menu-item-disabled
  ) {
  background-color: #f3f3f3 !important;
}
/deep/.ant-select-dropdown-menu-item-selected {
  background-color: #f3f3f3 !important;
}
/deep/.ant-select-dropdown-menu-item-active:not(
    .ant-select-dropdown-menu-item-disabled
  ) {
  background-color: #f3f3f3 !important;
}
/deep/ .roomNumber .ant-select-dropdown-menu {
  max-height: 250px !important;
}

/deep/.otherSelect {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/deep/.otherSelect .ant-select-dropdown-menu {
  max-height: 200px !important;
}
/deep/.ant-select-dropdown-menu-item-disabled {
  color: #bbbbbb;
}
/deep/.ant-select-search__field {
  margin-left: -4px;
  padding-left: 2px;
}
/deep/.van-field__body {
  line-height: 20px;
}

.avAssistanceTitle {
  font-family: $fontFamily;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #000000;
  position: relative;

  &:before {
    position: absolute;
    content: "*";
    left: -15px;
    width: 15px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.avAssistanceGroup-row {
  margin-top: 12px;
  display: flex;
  align-items: center;
  padding: 0 0 0 10px;

  height: 40px;
  border-radius: 6px;
  background: #f3f3f3;

  .xuehua,
  .taiyang {
    width: 16px;
    height: 16px;
    fill: $primary70-color !important;
  }

  img {
    width: 16px;
    height: 16px;
  }

  span {
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0em;
    font-family: $fontFamily;
    color: #000000;
    margin-left: 8px;
  }
}

.avAssistanceGroup-row-sel {
  // background: #f5f4f9;
  // border: 1px solid #9a94c0;
  border: 1px solid $primary-color;
  background-color: $primary70-color;

  span {
    color: #ffffff !important;
  }

  .xuehua,
  .taiyang {
    fill: #ffffff !important;
  }
}
</style>
